import React from 'react'
import { useTranslation } from 'react-i18next'
import { Flex } from './Library/Flex'
import { BorderBottom, InlineExternalSmallLink } from './Library'
import { LanguageSelect } from './LanguageSelect'
import { Text } from './Library/Typography'
import {Fixed} from "./Library/Fixed";
import { TERMS_OF_USE_URL, PRIVACY_POLICY_URL, CONTACT_US_URL } from '../constants/externalUrls'


export const Footer: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Fixed variant="footer">
      <BorderBottom pb={3} flexDirection="row">
        <Text textStyle="small">{t('common.nc')}</Text>
        <InlineExternalSmallLink
          pl={2}
          href={CONTACT_US_URL}
          target="_blank"
        >
          {t('footer.help')}
        </InlineExternalSmallLink>
        <LanguageSelect />
      </BorderBottom>
      <Text pt={3} pb={1} textStyle="small">
        {t('common.copy')}
      </Text>
      <Flex>
        <InlineExternalSmallLink
          href={TERMS_OF_USE_URL}
          target="_blank"
        >
          {t('footer.termsOfUse')}
        </InlineExternalSmallLink>{' '}
        <InlineExternalSmallLink
          pl={2}
          href={PRIVACY_POLICY_URL}
          target="_blank"
        >
          {t('footer.privacyPolicy')}
        </InlineExternalSmallLink>
      </Flex>
    </Fixed>
  )
}
